<div class="container">
    <div class="logo" (click)="goToHome()">
        <img class="logo" src="assets/images/ariadne-spatial-logo.png" alt="ariadne_logo" />
    </div>
    <h2>{{ code ?? 'Error' }}</h2>
    <p>{{ message ?? 'Something went wrong' }}</p>
    <cds-button action="flat" (click)="goToHome()">Return to Ariadne Viewer</cds-button>
</div>
